import {IController} from "angular";
import * as angular from "angular";

export class omsOrderLinkCtrl implements IController {

  id: any;

  constructor() {
  }

  $onInit() {
  }
}

angular
  .module('bringoz.admin.lean-planning')
  .component('planningRouteLink', {
    bindings: {
      id: '<'
    },
    template: require('./planning-route-link.html').default,
    controller: omsOrderLinkCtrl
  });
